
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/zaloz-konto",
      function () {
        return require("private-next-pages/zaloz-konto.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/zaloz-konto"])
      });
    }
  